export default "__VITE_ASSET__CC$e0QiX__"